export const X_AXIS_LABEL_KEY = 'xAxisLabel' as const
export const DEFAULT_LINE_CHART_HEIGHT = 270
export const MAX_CHART_LEGEND_TEXT_WIDTH = 250
export const MAIN_DATA_KEY = 'values'
export const ADDITIONAL_DATA_KEY = 'additionValues'
export const ADDITION_SUFFIX = '-addition'
export const ADDITIONS_OPACITY = 0.7
export const TEXT_SIZE = 12
